import React from 'react'

const Earnings = () => {
    return (
        <div>Earnings</div>
    )
}

export default Earnings